import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserLoad = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.0001 6.23892L18.4324 5.64542L17.8418 8.19852M3.00002 17.7632L5.56772 18.3567L6.15832 15.8036M18.4041 5.86132C21.7434 9.31632 21.721 14.8244 18.3195 18.2522C16.1896 20.3986 13.2337 21.2266 10.4656 20.7313M5.59532 18.1399C2.25602 14.6849 2.27842 9.17682 5.67992 5.74902C7.80982 3.60262 10.7657 2.77462 13.5338 3.26992",
		stroke: "#4C5AFF",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.5 16.5607C8.5 15.4039 9.41654 13.959 12.0446 13.959C14.6794 13.959 15.5959 15.3902 15.5959 16.5471M14.3109 9.76509C14.3109 11.0163 13.2971 12.0302 12.0459 12.0302C10.7946 12.0302 9.78076 11.0163 9.78076 9.76509C9.78076 8.51384 10.7946 7.5 12.0459 7.5C13.2971 7.5 14.3109 8.51384 14.3109 9.76509Z",
		stroke: "#4C5AFF",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUserLoad;
